import { APP_DICTIONARY } from '@/common/messages/root';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const Page = defineMessages({
  title: {
    id: 'app.auth.login.Page.title',
  },
  subTitle: {
    id: 'app.auth.login.Page.subTitle',
  },
  loginError: {
    id: 'app.auth.login.Page.loginError',
  },
});

export const Form = defineMessages({
  email: APP_DICTIONARY.email,
  password: APP_DICTIONARY.password,
  passwordRequired: {
    id: 'app.auth.login.Form.passwordRequired',
  },
  login: {
    id: 'app.auth.login.Form.login',
  },
  forgotPassword: {
    id: 'app.auth.login.Form.forgotPassword',
  },
});
